import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IsApplicationService } from '../../../../core/services/is-application.service';
import { LanguageService } from '../../../../core/services/language.service';
import { LinkService } from '../../../../core/services/link.service';
import { RoutingService } from '../../../../core/services/routing.service';

import { TabRoute } from '../../../../shared/models/interfaces/tab-route.interface';

import { RouterAnimations } from '../../../../shared/animations/route-animations';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
  providers: [RoutingService],
  animations: [RouterAnimations.routeSlide],
})
export class LegalComponent implements OnInit {
  tabRoutes: TabRoute[] = [];

  constructor(
    public router: Router,
    public linkService: LinkService,
    public isApplicationService: IsApplicationService,
    public routingService: RoutingService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.tabRoutes.push({
      routerLink: ['/legal/cgu'],
      label: 'cgu.utilisation',
      labelMobile: 'cgu.cgu_short',
      id: 'cgu',
    });

    if (!this.isApplicationService.isAppIos()) {
      this.tabRoutes.push({
        routerLink: ['/legal/cgv'],
        label: 'cgu.vente',
        labelMobile: 'cgu.vente_short',
        id: 'cgv',
      });
    }

    this.tabRoutes.push({
      routerLink: ['/legal/mentions'],
      label: 'cgu.mentions',
      id: 'mentions',
    });

    this.tabRoutes.push({
      routerLink: ['/legal/confidentiality'],
      label: 'cgu.confidentialite',
      labelMobile: 'cgu.confidentialite_short',
      id: 'confidentiality',
    });

    this.routingService.setupRouting(this.tabRoutes);
  }
}
